import React from "react";
import { Link } from "react-router-dom";
import "../css/HistoryMilestone.css";

const heroImage = "./images/hm.jpeg";

const journeyImage = "./images/hmh.jpeg";

const HistoryMilestone = () => {
  return (
    <>
      {}

      <section
        className="history-hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="history-overlay">
          <div className="container hero-content">
            <span className="hero-tag">Our Legacy</span>

            <h1>
              History &<span> Milestones</span>
            </h1>

            <p>
              Discover the inspiring journey of Sahara Public School Nepal and
              the milestones that define our commitment to excellence.
            </p>

            <div className="hero-buttons">
              <Link to="/admission" className="global-btn">
                Apply Now
              </Link>

             <Link to="/contact" className="global-btn">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {}

      <section className="journey-section">
        <div className="container journey-wrapper">
          <div className="journey-image">
            <img src={journeyImage} alt="School Journey" />
          </div>

          <div className="journey-content">
            <span className="section-label">Our Journey</span>

            <h2>Building Futures Since Our Foundation</h2>

            <p>
              Sahara Public School Nepal was established with a vision to
              provide world-class education while nurturing values, creativity
              and leadership among students.
            </p>

            <p>
              Over the years, the school has continuously evolved by introducing
              modern teaching methods, experienced faculty, digital classrooms
              and holistic student development.
            </p>

           <Link to="/about" className="global-btn">
              Learn More
            </Link>
          </div>
        </div>
      </section>
      {}

      <section className="timeline-section">
        <div className="container">
          <div className="section-heading">
            <span>School Milestones</span>

            <h2>Our Journey of Growth & Excellence</h2>

            <p>
              Every milestone reflects our commitment towards quality education
              and continuous improvement.
            </p>
          </div>

          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-year">2012</div>

              <div className="timeline-content">
                <h3>School Established</h3>

                <p>
                  Sahara Public School Nepal was founded with a vision to
                  provide quality education for every child.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-year">2015</div>

              <div className="timeline-content">
                <h3>Academic Recognition</h3>

                <p>
                  Achieved excellent academic results and became one of the
                  trusted schools in the region.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-year">2018</div>

              <div className="timeline-content">
                <h3>Modern Infrastructure</h3>

                <p>
                  Expanded campus with science laboratories, computer labs and
                  smart classrooms.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-year">2022</div>

              <div className="timeline-content">
                <h3>Holistic Development</h3>

                <p>
                  Introduced sports, leadership and co-curricular programmes for
                  all students.
                </p>
              </div>
            </div>

            <div className="timeline-item">
              <div className="timeline-year">2025</div>

              <div className="timeline-content">
                <h3>Growing Community</h3>

                <p>
                  Continuing our journey with modern education, dedicated
                  teachers and future-ready learning.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {}

      <section className="achievement-section">
        <div className="container">
          <div className="section-heading">
            <span>Achievements</span>

            <h2>Our Numbers Speak for Us</h2>
          </div>

          <div className="achievement-grid">
            <div className="achievement-card">
              <h3>1000+</h3>

              <p>Students</p>
            </div>

            <div className="achievement-card">
              <h3>100+</h3>

              <p>Qualified Teachers</p>
            </div>

            <div className="achievement-card">
              <h3>98%</h3>

              <p>Academic Success</p>
            </div>

            <div className="achievement-card">
              <h3>25+</h3>

              <p>School Awards</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HistoryMilestone;
